import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link, useParams } from "react-router-dom";
import {
	Row,
	Col,
	Dropdown,
	Card,
	Carousel,
	CardHeader,
} from "react-bootstrap";
import { AnchorComponent, ButtonComponent } from "../../components/elements";
import LabelTextareaComponent from "../../components/fields/LabelTextareaComponent";
import PageLayout from "../../layouts/PageLayout";
import specifics from "../../assets/data/specifics.json";
import reviews from "../../assets/data/reviews.json";
import Table from "react-bootstrap/Table";
import axios from "axios";
import moment from "moment";
import audio from "../../assets/audio.mp3";
import Swal from "sweetalert2";
import PhotoOutlinedIcon from "@mui/icons-material/PhotoOutlined";
import "react-quill/dist/quill.snow.css";
import "./EditDraftStyling.css";
import noImage from "../../assets/images/image.png";

import { FaUser, FaIdCard, FaIdCardAlt } from "react-icons/fa";

import { Form, FloatingLabel, Button, CardBody, Modal } from "react-bootstrap";
export default function FamilyReportPage() {
	const AuthToken = localStorage.getItem("AuthUser");
	const { fsf_num } = useParams();
	const [family, SetFamily] = useState({});
	const { t } = useContext(TranslatorContext);
	const [family_story, setFamilyStory] = useState("");

	const [user, setUser] = useState(() => {
		const savedUser = localStorage.getItem("user");

		return savedUser ? JSON.parse(savedUser) : null;
	});
	const [previewUrl, setPreviewUrl] = useState(null); // track clicked image
	const [show, setShow] = useState(false);

	const openImage = (url) => {
		setPreviewUrl(url);
		setShow(true);
	};

	const handleCloseImage = () => {
		setShow(false);
	};

	const [showVideo, setShowVideo] = useState(false);
	const [videoUrl, setVideoUrl] = useState(null);

	const openVideo = (url) => {
		setVideoUrl(url);
		setShowVideo(true);
	};

	const handleCloseVideo = () => {
		setShowVideo(false);
		setVideoUrl(null);
	};
	const handleSaveStory = async () => {
		try {
			axios.defaults.headers.common[
				"Authorization"
			] = `Bearer ${AuthToken}`;
			const response = await axios
				.post(process.env.REACT_APP_API_URL + "/update-family-story", {
					family_story: family_story,
					person_id: family.id,
				})
				.then((res) => {
					if (res.data.success) {
						Swal.fire({
							title: "Success!",
							text: "Draft updated successfully.",
							icon: "success",
							confirmButtonText: "Ok",
						});
					} else {
						Swal.fire({
							title: "Error!",
							text: "Please fill in the required fields.",
							icon: "error",
							confirmButtonText: "Ok",
						});
					}
				});
		} catch (error) {
			console.error("Error posting data:", error);
		}
	};
	useEffect(() => {
		if (family?.family_story) {
			setFamilyStory(family.family_story);
		}
	}, [family]);
	useEffect(() => {
		localStorage.setItem("user", JSON.stringify(user));
	}, [user]);
	useEffect(() => {
		const fetchData = async () => {
			try {
				axios.defaults.headers.common[
					"Authorization"
				] = `Bearer ${AuthToken}`;
				const response = await axios.get(
					process.env.REACT_APP_API_URL + "/family-report/" + fsf_num
				);
				SetFamily(response.data.person);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchData();
	}, [fsf_num]);

	const audioUrl = family?.family_story_audio
		? `${process.env.REACT_APP_IMG_URL}${family?.family_story_audio}`
		: null;

	const calculateAge = (dob) => {
		if (!dob) return null; // Return null if no date is provided
		const age = moment().diff(moment(dob, "YYYY-MM-DD"), "years");
		return age;
	};
	const fields = [
		"release_img",
		"new_home_img",
		"affidavit",
		"family_working_img",
		"family_check_img",
		"relocation_img",
		"img_1",
		"img_2",
		"img_3",
		"img_4",
		"img_5",
		"img_6",
	];

	return (
		<PageLayout>
			<div className="mc-card mb-4">
				<div className="mc-breadcrumb">
					<h3 className="mc-breadcrumb-title">{"Family Report"}</h3>
					<ul className="mc-breadcrumb-list">
						<li className="mc-breadcrumb-item">
							<Link
								to="/"
								className="mc-breadcrumb-link"
							>
								{t("home")}
							</Link>
						</li>

						<li className="mc-breadcrumb-item">
							{"Family Report"}
						</li>
					</ul>
				</div>
			</div>
			<div className="mc-card ">
				<Row className="gy-3 gx-3">
					<Col xl={12}>
						<h5 className="mc-divide-title mb-4">
							<small>
								{t("Data Entered By")}: {family?.enter_by?.name}
							</small>{" "}
						</h5>
					</Col>
					<Col xl={5}>
						<div className="mc-product-view-gallery">
							{family?.avatar ? (
								<img
									src={
										process.env.REACT_APP_IMG_URL +
										family.avatar
									}
									alt="Avatar"
									className="nic"
									style={{
										cursor: "pointer",
										width: "290px",
										height: "290px",
										display: "block",
										margin: "20px auto",
									}}
									onClick={() =>
										openImage(
											process.env.REACT_APP_IMG_URL +
												family.avatar
										)
									}
								/>
							) : (
								<div style={{ textAlign: "center" }}>
									<img
										src={noImage}
										alt="No Avatar"
										className="nic"
										style={{
											width: "320px",
											cursor: "pointer",
											opacity: 0.7,
											display: "block",
											margin: "0 auto",
										}}
									/>
									<p
										style={{
											fontSize: "0.9rem",
											color: "red",
											marginTop: "0.5rem",
										}}
									>
										No image available
									</p>
								</div>
							)}
						</div>
					</Col>
					<Col xl={6}>
						<div className="mc-product-view-info-group">
							<h2 className="mc-product-view-info-title">
								{family?.f_number} | {family?.beneficiary_name}
							</h2>
							<div className="mc-product-view-meta">
								<i className="material-icons">check</i>
								<h5>Stage</h5>
								<span>:</span>
								<span className="badge badge-success">
									{family?.stage?.name}
								</span>
							</div>
                            {family?.rescue_date ? 	<div className="mc-product-view-meta">
								<i className="material-icons">calendar_view_month</i>
								<h5>Rescue Date</h5>
								<span>:</span>
								
									{family?.rescue_date}
								
							</div>:''  }
                            
							<div className="mc-product-view-meta">
								<i className="material-icons">
									supervised_user_circle
								</i>
								<h5>Gender</h5>
								<span>:</span>
								{family?.gender?.name} |{" "}
								{calculateAge(family?.dob)} Years
							</div>

							<div className="mc-product-view-meta">
								<i className="material-icons">diversity_1</i>
								<h5>Marital Status</h5>
								<span>:</span>
								{family?.marital_status?.name}
							</div>
							<div className="mc-product-view-meta">
								<i className="material-icons">
									not_listed_location
								</i>
								<h5>Slavery Years</h5>
								<span>:</span>
								{family?.slavery_years} Years
							</div>
							<div className="mc-product-view-meta">
								<i className="material-icons">credit_card</i>
								<h5>CNIC</h5>
								<span>:</span>
								{family?.cnic}
							</div>
							<div className="mc-product-view-meta">
								<i className="material-icons">calendar_month</i>
								<h5>CNIC Expiry Date</h5>
								<span>:</span>
								{family?.cnic_expire_date}
							</div>
						</div>
						<Row>
							<Col md={6}>
								<Card className="rounded">
									{family?.cnic_f_img ? (
										<img
											className="nic"
											src={
												process.env.REACT_APP_IMG_URL +
												family.cnic_f_img
											}
											alt="CNIC Front"
											style={{
												cursor: "pointer",
											}}
											onClick={() =>
												openImage(
													process.env
														.REACT_APP_IMG_URL +
														family.cnic_f_img
												)
											}
										/>
									) : (
										<div style={{ textAlign: "center" }}>
											<img
												className="nic"
												src={noImage}
												alt="No CNIC Front Image"
												style={{
													width: "120px",
													opacity: "0.7",
													cursor: "pointer",
													display: "block",
													margin: "0 auto",
												}}
											/>
											<p
												style={{
													fontSize: "0.9rem",
													color: "red",
													marginTop: "0.5rem",
												}}
											>
												No image available
											</p>
										</div>
									)}
								</Card>
							</Col>
							<Col md={6}>
								<Card className="rounded">
									{family?.cnic_b_img ? (
										<img
											className="nic"
											src={
												process.env.REACT_APP_IMG_URL +
												family.cnic_b_img
											}
											alt="CNIC Back"
											style={{ cursor: "pointer" }}
											onClick={() =>
												openImage(
													process.env
														.REACT_APP_IMG_URL +
														family.cnic_b_img
												)
											}
										/>
									) : (
										<div style={{ textAlign: "center" }}>
											<img
												className="nic"
												src={noImage}
												alt="No CNIC Back Image"
												style={{
													width: "120px",
													opacity: "0.7",
													cursor: "pointer",
													display: "block",
													margin: "0 auto",
												}}
											/>
											<p
												style={{
													fontSize: "0.9rem",
													color: "red",
													marginTop: "0.5rem",
												}}
											>
												No image available
											</p>
										</div>
									)}
								</Card>
							</Col>
						</Row>

						<Modal
							show={show}
							onHide={handleCloseImage}
							onExited={() => setPreviewUrl(null)}
							centered
							size="xl"
							dialogClassName="fullscreen-modal"
						>
							<Modal.Body className="p-0 position-relative">
								<button
									type="button"
									className="btn-close position-absolute"
									style={{
										top: "1rem",
										right: "1rem",
										backgroundColor: "rgba(0,0,0,0.5)",
										borderRadius: "50%",
										padding: "0.6rem",
										filter: "invert(1)",
									}}
									onClick={handleCloseImage}
								/>

								{previewUrl ? (
									<img
										src={previewUrl}
										alt="Preview"
										style={{
											width: "100%",
											height: "90vh",
											objectFit: "contain",
										}}
									/>
								) : (
									<div className="text-center text-white ">
										<img
											src={noImage}
											alt="No image"
											style={{
												width: "200px",
												opacity: "0.7",
												marginBottom: "1rem",
											}}
										/>
										<p
											style={{
												fontSize: "1.2rem",
												color: "red",
												backgroundColor: "transparent",
											}}
										>
											No image found
										</p>
									</div>
								)}
							</Modal.Body>
						</Modal>
					</Col>

					<Col md={12}>
						<h5 className="mc-divide-title mt-5 mb-4">
							{family?.f_number} | {family?.beneficiary_name}
							{" More Details"}
						</h5>
						<Row>
							<Col
								md={4}
								className="mb-3"
							>
								
								<div className="mc-product-view-meta">
									<i className="material-icons">drafts</i>
									<h5>Assesment Date</h5>
									<span>:</span>
									{moment(
										family?.assesment_date,
										"YYYY-MM-DD"
									).format("ll")}
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								{" "}
								<div className="mc-product-view-meta">
									<i className="material-icons">
										calendar_month
									</i>
									<h5>Entry Date</h5>
									<span>:</span>
									{moment(
										family?.created_at,
										"YYYY-MM-DD"
									).format("ll")}
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								{" "}
								<div className="mc-product-view-meta">
									<i className="material-icons">
										calendar_month
									</i>
									<h5>Verification Date</h5>
									<span>:</span>
									{moment(
										family?.verification_date,
										"YYYY-MM-DD"
									).format("ll")}
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								{" "}
								<div className="mc-product-view-meta">
									<i className="material-icons">
										settings_cell
									</i>
									<h5>Cell:</h5>
									<span>:</span>
									{family?.mob}
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								{" "}
								<div className="mc-product-view-meta">
									<i className="material-icons">mosque</i>
									<h5>Religion:</h5>
									<span>:</span>
									{family?.faith?.name}
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								{" "}
								<div className="mc-product-view-meta">
									<i className="material-icons">
										credit_card
									</i>
									<h5>Slavery Reason</h5>
									<span>:</span>
									{family?.slavery_reason?.name}
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								{" "}
								<div className="mc-product-view-meta">
									<i className="material-icons">
										energy_savings_leaf
									</i>
									<h5>Occupation</h5>
									<span>:</span>
									{family?.occupation?.name}
								</div>
							</Col>

							{/* cris */}

							{/* <Col md={4} className="mb-3">  <div className="mc-product-view-meta">
                                <i className="material-icons">blur_circular</i>
                                <h5>Abused</h5>
                                <span>:</span>
                                {family?.abused?.name}
                            </div></Col> */}
							<Col
								md={4}
								className="mb-3"
							>
								{" "}
								<div className="mc-product-view-meta">
									<i className="material-icons">flag</i>
									<h5>Flagged</h5>
									<span>:</span>
									{family?.flagged ? "Yes" : "No"}
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								{" "}
								<div className="mc-product-view-meta">
									<i className="material-icons">water_drop</i>
									<h5>Baptized</h5>
									<span>:</span>
									{family?.baptised ? "Yes" : "No"}
								</div>
							</Col>
						</Row>
						{family?.is_member_of_church ? (
							<Row>
								<h5 className="mc-divide-title mt-5 mb-4">
									{"Church Details"}
								</h5>
								<Col
									md={4}
									className="mb-3"
								>
									<div className="mc-product-view-meta">
										<i className="material-icons">
											water_drop
										</i>
										<h5>Church Name</h5>
										<span>:</span>
										{family?.church_name}
									</div>
								</Col>
								<Col
									md={4}
									className="mb-3"
								>
									<div className="mc-product-view-meta">
										<i className="material-icons">
											water_drop
										</i>
										<h5>Pastor Name</h5>
										<span>:</span>
										{family?.pastor_name}
									</div>
								</Col>
								<Col
									md={4}
									className="mb-3"
								>
									<div className="mc-product-view-meta">
										<i className="material-icons">
											water_drop
										</i>
										<h5>Pastor Cell Number</h5>
										<span>:</span>
										{family?.pastor_cell_number}
									</div>
								</Col>
								<Col
									md={4}
									className="mb-3"
								>
									<div className="mc-product-view-meta">
										<i className="material-icons">
											water_drop
										</i>
										<h5>How Frequent</h5>
										<span>:</span>
										{family?.frequent}
									</div>
								</Col>

								<Col
									md={4}
									className="mb-3"
								>
									<div className="mc-product-view-meta">
										<i className="material-icons">
											water_drop
										</i>
										<h5>Last time went to Church</h5>
										<span>:</span>
										{family?.last_time_church}
									</div>
								</Col>
								<Col
									md={4}
									className="mb-3"
								>
									<div className="mc-product-view-meta">
										<i className="material-icons">
											water_drop
										</i>
										<h5>Is Visited By Pastor</h5>
										<span>:</span>
										{family?.is_visited_by_pastor
											? "Yes"
											: "No"}
									</div>
								</Col>
							</Row>
						) : (
							""
						)}
					</Col>

					<h5 className="mc-divide-title mt-5 mb-4">
						{t("Address Details")}
					</h5>

					<Col
						md={4}
						className="mb-3"
					>
						{" "}
						<div className="mc-product-view-meta">
							<i className="material-icons">business</i>
							<h5>Province</h5>
							<span>:</span>
							{family?.city?.province?.name}
						</div>
					</Col>

					<Col
						md={4}
						className="mb-3"
					>
						{" "}
						<div className="mc-product-view-meta">
							<i className="material-icons">cabin</i>
							<h5>City</h5>
							<span>:</span>
							{family?.city?.name}
						</div>
					</Col>

					<Col
						md={4}
						className="mb-3"
					>
						{" "}
						<div className="mc-product-view-meta">
							<i className="material-icons">castle</i>
							<h5>Union Council</h5>
							<span>:</span>
							{family?.union_council}
						</div>
					</Col>

					<Col
						md={6}
						className="mb-3"
					>
						<div className="mc-card address">
							<div>
								<h5>Present Address/Residense</h5>
								<p>{family?.present_address}</p>
							</div>
						</div>
					</Col>
					<Col
						md={6}
						className="mb-3"
					>
						<div className="mc-card address">
							<div>
								<h5>Permanent Address</h5>
								<p>{family?.permanent_address}</p>
							</div>
						</div>
					</Col>
					{/* <Col xl={12}>
                        <h5 className="mc-divide-title mt-5 mb-4">Family Assesment</h5>
                        <Row>
                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">calendar_today</i>
                                    <h5>Working Years on Brick Kiln</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.working_years_on_brick_kiln}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">event</i>
                                    <h5>Loan Year</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.loan_year}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">attach_money</i>
                                    <h5>First Loan Amount</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.first_loan_amount}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">group</i>
                                    <h5>Number of Dependents</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.number_of_dependents}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">work</i>
                                    <h5>Number of Work Dependents</h5>
                                    <span>:</span> {family?.brick_assessment?.number_of_work_dependents}

                                    {family?.brick_assessment?.worker_list?.length > 0 && (
                                        <div className="mt-2 ps-4">
                                            {family.brick_assessment.worker_list.map((worker, index) => (
                                                <div key={index} className="d-flex align-items-center mb-1">
                                                    <small><strong>{worker.relation}:</strong> {worker.name}</small>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </Col>




                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">home</i>
                                    <h5>Live on Brick Kiln</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.live_on_brick_kiln ? "Yes" : "No"}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">thumb_up</i>
                                    <h5>Live by Choice</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.live_by_choice ? "Yes" : "No"}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">comment</i>
                                    <h5>Reason</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.reason}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">people</i>
                                    <h5>Allowed to Meet Relatives</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.is_allow_to_meet_relatives ? "Yes" : "No"}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">location_on</i>
                                    <h5>Living Address</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.living_address}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">directions_walk</i>
                                    <h5>Distance to Home</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.distance_to_home}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">schedule</i>
                                    <h5>Working Hours</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.working_hours} hrs
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">exit_to_app</i>
                                    <h5>Want to Leave Work</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.want_to_leave_work ? "Yes" : "No"}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">help</i>
                                    <h5>Why</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.why}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">business_center</i>
                                    <h5>Plans After Leaving Work</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.plans_after_leaving_work}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">school</i>
                                    <h5>Willing to Learn New Skills</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.willing_to_learn_new_skills ? "Yes" : "No"}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">design_services</i>
                                    <h5>New Skill or Job</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.new_skill_or_job}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">payments</i>
                                    <h5>Willing to Pay in Installments</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.willing_to_pay_in_installments ? "Yes" : "No"}
                                </div>
                            </Col>

                            <Col md={4} className="mb-3">
                                <div className="mc-product-view-meta">
                                    <i className="material-icons">child_care</i>
                                    <h5>Willing to Educate Children</h5>
                                    <span>:</span>
                                    {family?.brick_assessment?.willing_to_educate_children ? "Yes" : "No"}
                                </div>
                            </Col>
                        </Row>

                    </Col> */}
				</Row>
			</div>

			<div className="mc-card p-lg-4">
				<Row>
					<Col xl={12}>
						<h5 className="mc-divide-title mt-5 mb-4">
							Family Details
						</h5>

						<Row>
							<Col md={4}>
								<h6 className="mc-divide-title mb-4">
									{" "}
									<i className="material-icons">girl</i>{" "}
									Spouse Information
								</h6>

								<div className="mc-product-view-meta mb-2">
									<i className="material-icons">
										supervised_user_circle
									</i>
									<h5>Gender</h5>
									<span>:</span>
									{family?.gender_id == 1 ? "Female" : "Male"}
								</div>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">girl</i>
									<h5>Name:</h5>
									<span>:</span>
									{family?.family?.spouse_name ||
										"NOT Provided "}
								</div>

								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										calendar_today
									</i>
									<h5>Age</h5>
									<span>:</span>
									{calculateAge(family?.family?.spouse_dob)}
								</div>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										calendar_view_month
									</i>
									<h5>Slavery Years</h5>
									<span>:</span>
									{family?.family?.spouse_slavry_year} Years
								</div>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										credit_card
									</i>
									<h5>CNIC</h5>
									<span>:</span>
									<span className="font-12">
										{" "}
										{family?.family?.spouse_cnic}
									</span>
								</div>

								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										monitor_heart
									</i>
									<h5>Alive</h5>
									<span>:</span>
									{family?.family?.spouse_is_dead == 0
										? "Yes"
										: "No"}
								</div>
							</Col>

							<Col md={4}>
								<h6 className="mc-divide-title mb-4">
									{" "}
									<i className="material-icons">
										person_4
									</i>{" "}
									Father Information
								</h6>
								<div className="mc-product-view-meta mb-2">
									<i className="material-icons">
										supervised_user_circle
									</i>
									<h5>Gender</h5>
									<span>:</span>
									Male
								</div>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">boy</i>
									<h5>Name:</h5>
									<span>:</span>
									{family?.family?.father_name}
								</div>

								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										calendar_today
									</i>
									<h5>Age</h5>
									<span>:</span>
									{calculateAge(
										family?.family?.father_dob
									)}{" "}
									Years
								</div>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										calendar_view_month
									</i>
									<h5>Slavery Years</h5>
									<span>:</span>
									{family?.family?.father_slavry_years} Years
								</div>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										credit_card
									</i>
									<h5>CNIC</h5>
									<span>:</span>
									<span className="font-12">
										{family?.family?.father_cnic}
									</span>
								</div>

								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										monitor_heart
									</i>
									<h5>Alive</h5>
									<span>:</span>
									{family?.family?.father_is_dead == 0
										? "Yes"
										: "No"}
								</div>
							</Col>

							<Col md={4}>
								<h6 className="mc-divide-title mb-4">
									{" "}
									<i className="material-icons">
										person_3
									</i>{" "}
									Mother Information
								</h6>
								<div className="mc-product-view-meta mb-2">
									<i className="material-icons">
										supervised_user_circle
									</i>
									<h5>Gender</h5>
									<span>:</span>
									Female
								</div>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">girl</i>
									<h5>Name:</h5>
									<span>:</span>
									{family?.family?.mother_name}
								</div>

								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										calendar_today
									</i>
									<h5>Age</h5>
									<span>:</span>
									{calculateAge(
										family?.family?.mother_dob
									)}{" "}
									Years
								</div>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										calendar_view_month
									</i>
									<h5>Slavery Years</h5>
									<span>:</span>
									{family?.family?.mother_slavry_years} Years
								</div>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										credit_card
									</i>
									<h5>CNIC</h5>
									<span>:</span>
									<span className="font-12">
										{family?.family?.mother_cnic}
									</span>
								</div>

								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										monitor_heart
									</i>
									<h5>Alive</h5>
									<span>:</span>
									{family?.family?.mother_is_dead == 0
										? "Yes"
										: "No"}
								</div>
							</Col>
						</Row>
					</Col>
					<Col
						xl={12}
						className="mt-5"
					>
						<h5 className="mc-divide-title mb-4">
							{"Children's Detail"}
						</h5>

						<Table
							striped
							bordered
							hover
						>
							<thead>
								<tr>
									<th>#</th>
									<th>Name</th>
									<th>Age</th>
									<th>CNIC</th>
									<th>Slavery Years</th>
									<th>School Going</th>

									<th>Training Refer</th>
								</tr>
							</thead>
							<tbody>
								{family?.childrens?.map((kid, i) => {
									return (
										<tr>
											<td>{i + 1}</td>
											<td>{kid.name}</td>
											<td>{calculateAge(kid.dob)}</td>
											<td>{kid.cnic}</td>
											<td>{kid.slavery_years}</td>
											<td>
												{kid.school_going == 1
													? "Yes"
													: "No"}
											</td>
											<td>
												{kid.vocational_center == 1
													? "Yes"
													: "No"}
											</td>
										</tr>
									);
								})}
							</tbody>
						</Table>
					</Col>
					<Col
						xl={12}
						className="mt-5"
					>
						<h5 className="mc-divide-title mb-4">
							{"Kin's Detail"}
						</h5>

						<Table
							striped
							bordered
							hover
						>
							<thead>
								<tr>
									<th>#</th>
									<th>Relation</th>
									<th>Name</th>
									<th>Age</th>
									<th>CNIC</th>
									<th>Slavery Years</th>
								</tr>
							</thead>
							<tbody>
								{family?.kins?.map((kin, i) => {
									return (
										<tr>
											<td>{i + 1}</td>
											<td>{kin.relation?.name}</td>
											<td>{kin.name}</td>
											<td>{calculateAge(kin.dob)}</td>
											<td>{kin.cnic}</td>
											<td>{kin.slavery_years}</td>
										</tr>
									);
								})}
							</tbody>
						</Table>
					</Col>
				</Row>
			</div>
			{/* IMAGE GALLERY */}
			<div className="mc-card">
				<h5 className="mc-divide-title mb-4">Family Images Gallery</h5>
				<Carousel>
					{fields?.map((field, index) =>
						family?.[field] ? (
							<Carousel.Item key={index}>
								<div className="img-container">
									<img
										className="img-gallery"
										src={
											process.env.REACT_APP_IMG_URL +
											family[field]
										}
										alt={`Image for ${field}`}
										onClick={() => {
											openImage(
												process.env.REACT_APP_IMG_URL +
													family[field]
											);
										}}
									/>
									<div className="text-bar">
										{field}{" "}
										{/* Replace with dynamic text if needed */}
									</div>
								</div>
							</Carousel.Item>
						) : null
					)}
				</Carousel>
			</div>
			
			{/* Family Story */}
			<div className="mc-card p-lg-4">
				<Row>
					{(user?.permissions || []).some(
						(p) => p.name === "Story Writer"
					) ? (
						<Col
							xl={12}
							className="mt-2 border"
						>
							<h5 className="mc-divide-title mb-4 mt-2">
								Family Story
							</h5>
							<div className="mc-product-view-descrip">
								<textarea
									value={family_story}
									placeholder="Enter family story"
									onChange={(e) =>
										setFamilyStory(e.target.value)
									}
									rows={7}
									style={{
										width: "100%",
										border: "1px solid #ccc",
										borderRadius: "4px",
										padding: "10px",
									}}
								/>
								<button
									type="button"
									style={{ backgroundColor: "#077834" }}
									className="btn  my-2"
									onClick={handleSaveStory}
								>
									Save
								</button>
							</div>
						</Col>
					) : (
						<Col
							xl={12}
							className="mt-5"
						>
							<h5 className="mc-divide-title mb-4">
								Family Story
							</h5>
							<div className="mc-product-view-descrip">
								<p>
									{family?.family_story ||
										"No story available"}
								</p>
							</div>
						</Col>
					)}
			
				</Row>
			</div>
<div className="mc-card">
                <Row>
				{/* <h5 className="mc-divide-title mb-4">Family Story</h5> */}

				<Col
					md={6}
					className="mb-4"
				>
					<Card>
						<Card.Body>
							<Card.Title>
								<small>Family Story Video</small>
							</Card.Title>

							<div
								style={{
									width: "100%",
									height: "150px",
									border: "1px dashed #ddd",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									marginBottom: "10px",
									position: "relative",
									backgroundColor: "#f9f9f9",
								}}
							>
								{family.testimony_video_link ? (
									<video
										width="100%"
										height="100%"
										controls
										style={{
											objectFit: "cover",
											borderRadius: "8px",
										}}
									>
										<source
											src={
												process.env.REACT_APP_IMG_URL + family.testimony_video_link
												
											}
											type="video/mp4"
										/>
										Your browser does not support the video
										tag.
									</video>
								) : (
									<span style={{ color: "#666" }}>
										No Video Uploaded
									</span>
								)}
							</div>
						</Card.Body>
					</Card>
				</Col>
                    <Col
                                                                                    md={6}
                                                                                    className="mb-4"
                                                                                >
                                                                                    <Card>
                                                                                        <Card.Body>
                                                                                            <Card.Title>
                                                                                                <small>Family Story Audio</small>
                                                                                            </Card.Title>
                                                            
                                                                                            <div
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    height: "150px",
                                                                                                    border: "1px dashed #ddd",
                                                                                                    display: "flex",
                                                                                                    justifyContent: "center",
                                                                                                    alignItems: "center",
                                                                                                    marginBottom: "10px",
                                                                                                    position: "relative",
                                                                                                    backgroundColor: "#f9f9f9",
                                                                                                }}
                                                                                            >
                                                                                                {family.family_story_audio ? (
                                                                                                <audio controls>
                                                                <source
                                                                    src={audioUrl}
                                                                    type="audio/mpeg"
                                                                />
                                                                Your browser does not support
                                                                the audio element.
                                                            </audio>
                                                                                                ) : (
                                                                                                    <span style={{ color: "#666" }}>
                                                                                                        No Audio Uploaded
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        </Card.Body>
                                                                                    </Card>
                                                                                </Col>

                                                                                </Row>
			</div>
			<div className="mc-card p-lg-4">
				<Row>
					<Col
						xl={12}
						className="mt-5"
					>
						<h5 className="mc-divide-title mb-4">
							Family Extra Comments
						</h5>
						<div className="mc-product-view-descrip">
							<p>{family?.extra_comments}</p>
						</div>
					</Col>
				</Row>
			</div>

			<div className="mc-card p-lg-4">
				<Row>
					<Col
						xl={12}
						className="mt-5"
					>
						<h5 className="mc-divide-title mb-4">
							Family Prayer Request
						</h5>
						<div className="mc-product-view-descrip">
							<p>{family?.prayer_request?.prayer}</p>
						</div>
					</Col>
				</Row>
			</div>

			{/* Payment Details*/}
			<div className="mc-card p-lg-4">
				<Row>
					<Col
						xl={12}
						className="mt-5"
					>
						<h5 className="mc-divide-title mb-4">
							Payment Details
						</h5>
						<Row>
							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">apartment</i>
									<h5>Brick Kiln</h5>
									<span>:</span>
									{family?.brick_kiln?.brickkiln_name}
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">payments</i>
									<h5>Loan Type</h5>
									<span>:</span>
									{family?.loan?.type?.name}
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">payment</i>
									<h5>Loan Amount</h5>
									<span>:</span>
									{family?.loan?.est_loan_amount} /-
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="unpaid loan invoice"
										onClick={() => {
											const imageUrl = family?.loan
												?.unpaid_loan_invoice
												? process.env
														.REACT_APP_IMG_URL +
												  family.loan
														.unpaid_loan_invoice
												: null;
											openImage(imageUrl);
										}}
									>
										<PhotoOutlinedIcon />
									</button>

										<button
										data-toggle="tooltip"
										data-placement="top"
										title="paid loan invoice"
										onClick={() => {
											const imageUrl = family?.loan?.loan_file
												? process.env
														.REACT_APP_IMG_URL +
												  family.loan?.loan_file
												: null;
											openImage(imageUrl);
										}}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>

							<Col md={4}>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										shopping_bag
									</i>
									<h5>Shop Khatta</h5>
									<span>:</span>
									{family?.loan?.khatta_amount} /-
									<button
										onClick={() => {
											const imageUrl = family?.loan
												?.khatta_unpaid_invoice
												? process.env
														.REACT_APP_IMG_URL +
												  family?.loan
														?.khatta_unpaid_invoice
												: null;
											openImage(imageUrl);
										}}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">medication</i>
									<h5>Medical Amount</h5>
									<span>:</span>
									{family?.loan?.medical_amount} /-
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="Medical File"
										onClick={() =>
											openImage(
												family?.loan?.medical_file
													? process.env
															.REACT_APP_IMG_URL +
															family.loan
																.medical_file
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="Medical File Received"
										onClick={() =>
											openImage(
												family?.loan?.medical_file_rc
													? process.env
															.REACT_APP_IMG_URL +
															family.loan
																.medical_file_rc
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">food_bank</i>
									<h5>Food Ration</h5>
									<span>:</span>
									{family?.loan?.food_ration} /-
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="Food File"
										onClick={() =>
											openImage(
												family?.loan?.food_file
													? process.env
															.REACT_APP_IMG_URL +
															family.loan
																.food_file
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">set_meal</i>
									<h5>Meal Amount</h5>
									<span>:</span>
									{family?.loan?.meal_amount} /-
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="Meal Amount"
										onClick={() =>
											openImage(
												family?.loan?.meal_file
													? process.env
															.REACT_APP_IMG_URL +
															family.loan
																.meal_file
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="Meal Amount Receipt"
										onClick={() =>
											openImage(
												family?.loan?.meal_file_rc
													? process.env
															.REACT_APP_IMG_URL +
															family.loan
																.meal_file_rc
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">newspaper</i>
									<h5>Utility Amount</h5>
									<span>:</span>
									{family?.loan?.utility_amount} /-
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="Utility File"
										onClick={() =>
											openImage(
												family?.loan?.utility_file
													? process.env
															.REACT_APP_IMG_URL +
															family.loan
																.utility_file
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										bedroom_parent
									</i>
									<h5>Rent Amount</h5>
									<span>:</span>
									{family?.loan?.rent_amount} /-
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="Rent Amount"
										onClick={() =>
											openImage(
												family?.loan?.rent_file
													? process.env
															.REACT_APP_IMG_URL +
															family.loan
																.rent_file
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">copy_all</i>
									<h5>Affidavit Amount</h5>
									<span>:</span>
									{family?.loan?.affidavit_amount} /-
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="affidavit Invoice"
										onClick={() =>
											openImage(
												family?.affidavit
													? process.env
															.REACT_APP_IMG_URL +
															family?.affidavit
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">360</i>
									<h5>Other Amount</h5>
									<span>:</span>
									{family?.loan?.other} /-
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="Other amount"
										onClick={() =>
											openImage(
												family?.loan?.other_file
													? process.env
															.REACT_APP_IMG_URL +
															family?.loan
																?.other_file
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">bus_alert</i>
									<h5>Transportation Amount</h5>
									<span>:</span>
									{family?.loan?.transportation} /-
									<button
										data-toggle="tooltip"
										data-placement="top"
										title="Transportation Image"
										onClick={() =>
											openImage(
												family?.loan?.transportation_file
													? process.env
															.REACT_APP_IMG_URL +
															family.loan
																.transportation_file
													: null
											)
										}
									>
										<PhotoOutlinedIcon />
									</button>
								</div>
							</Col>
							<Col md={6}>
								<h5 className="mc-divide-title mb-4">
									Loan Debt Ledger
								</h5>
								<Carousel>
									{family?.loan?.loan_images.map(
										(field, index) => (
											<Carousel.Item key={index}>
												<div className="img-container">
													<img
														className="img-gallery"
														src={
															process.env
																.REACT_APP_IMG_URL +
															field.img
														}
														alt={`Image for ${field}`}
														onClick={() => {
															openImage(
																process.env
																	.REACT_APP_IMG_URL +
																	field.img
															);
														}}
													/>
												</div>
											</Carousel.Item>
										)
									)}
								</Carousel>
							</Col>
							{/* 
                              <Col md={6}>
                             <h5 className="mc-divide-title mb-4">Shop Khatta Images</h5>
                                <Carousel

                                >
                                    {
                                        family?.loan?.khatta_images.map((field, index) =>
                                           
                                                <Carousel.Item key={index}>
                                                    <div className="img-container">
                                                        <img
                                                            className="img-gallery"
                                                            src={process.env.REACT_APP_IMG_URL + field.img}
                                                            alt={`Image for ${field}`}
                                                        />
                                                      
                                                    </div>
                                                </Carousel.Item>
                                          
                                        )
                                    }

                                </Carousel>
                            </Col> */}
							{/* <Col md={6}>
                                <Card className="" border="primary">
                                    <CardHeader className="bg-dark"><h6 className="text-light">Loan UnPaid Invoice</h6></CardHeader>

                                    <img className="invoice" src={process.env.REACT_APP_IMG_URL + family?.loan?.unpaid_loan_file} alt="unpaid_loan_file" />

                                </Card>
                            </Col>
                            <Col md={6}>
                                <Card className="" border="primary">
                                    <CardHeader className="bg-dark"><h6 className="text-light">Khatta UnPaid Invoice</h6></CardHeader>

                                    <img className="invoice" src={process.env.REACT_APP_IMG_URL + family?.loan?.khatta_unpaid_file} alt="khatta_unpaid_file" />
                                </Card>
                            </Col> */}
						</Row>
					</Col>
				</Row>
			</div>

			{/* Payment Details*/}
			<div className="mc-card p-lg-4">
				<Row>
					<Col
						xl={12}
						className="mt-5"
					>
						<h5 className="mc-divide-title mb-4">
							Business Details
						</h5>
						<Row>

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">payments</i>
									<h5>Estimated Cost</h5>
									<span>:</span>
									{family?.loan?.estimated_business_cost}
								</div>
							</Col>

								<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">event</i>
									<h5>Business Date</h5>
									<span>:</span>
									{family?.business?.business_date}
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">apartment</i>
									<h5>Business Type</h5>
									<span>:</span>
									{family?.business?.type?.name}
								</div>
							</Col>
							

						

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">info</i>
									<h5>Another Details</h5>
									<span>:</span>
									{family?.business?.another_details}
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										currency_rupee
									</i>
									<h5>Total pkr</h5>
									<span>:</span>
									{family?.business?.total_pkr} Rs
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										attach_money
									</i>
									<h5>Total Dollar</h5>
									<span>:</span>
									{family?.business?.total_dollar}
								</div>
							</Col>
							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta  mb-2">
									<i className="material-icons">
										attach_money
									</i>
									<h5>Resettlement Amount</h5>
									<span>:</span>
									{family?.business?.resettlement_amount}
								</div>
							</Col>

							{family?.stage_id === 12 ? (
								<>
									<Col
										md={4}
										className="mb-3"
									>
										<div className="mc-product-view-meta  mb-2">
											<i className="material-icons">
												payment
											</i>
											<h5>Equipment Cost </h5>
											<span>:</span>
											{
												family?.business?.equipment_cost
											}{" "}
											/-
											<button
												data-toggle="tooltip"
												data-placement="top"
												title="Equipment cost receipt"
												onClick={() =>
													openImage(
														process.env
															.REACT_APP_IMG_URL +
															family?.business
																?.equipment_cost_file
													)
												}
											>
												<PhotoOutlinedIcon />
											</button>
										</div>
									</Col>

									<Col
										md={4}
										className="mb-3"
									>
										<div className="mc-product-view-meta  mb-2">
											<i className="material-icons">
												payment
											</i>
											<h5>Stock Amount </h5>
											<span>:</span>
											{family?.business?.stock_amount} /-
											<button
												data-toggle="tooltip"
												data-placement="top"
												title="Stock Amount Receipt"
												onClick={() =>
													process.env
														.REACT_APP_IMG_URL +
													family?.business
														?.stock_amount_file
												}
											>
												<PhotoOutlinedIcon />
											</button>
										</div>
									</Col>
								</>
							) : (
								""
							)}

							<Col
								md={4}
								className="mb-3"
							>
								<div className="mc-product-view-meta mb-2">
									<i className="material-icons">payment</i>
									<h5>Video</h5>
									<span>:</span>

									<i
										data-toggle="tooltip"
										data-placement="top"
										title="Play the video"
										onClick={() =>
											openVideo(
												`${
													process.env
														.REACT_APP_IMG_URL
												}${
													family?.business?.y_link ||
													""
												}`
											)
										}
										className="material-icons"
									>
										play_circle_filled
									</i>
								</div>
							</Col>
							{showVideo && (
								<div
									className="modal fade show"
									style={{
										display: "block",
										background: "rgba(0,0,0,0.6)",
									}}
								>
									<div className="modal-dialog modal-lg modal-dialog-centered">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title">
													Video Preview
												</h5>
												<button
													type="button"
													className="btn-close"
													onClick={handleCloseVideo}
												></button>
											</div>
											<div className="modal-body">
												<video
													width="100%"
													height="400"
													controls
													autoPlay
												>
													<source
														src={videoUrl}
														type="video/mp4"
													/>
													Your browser does not
													support the video tag.
												</video>
											</div>
										</div>
									</div>
								</div>
							)}
							<Row>
<Col md={6}>
									<Card className="rounded mb-2 p-3">
<Card.Title>
								<small>Business Image</small>
							</Card.Title>										{family?.business?.business_img ? (
											<img
												className="cnic"
												src={
													process.env
														.REACT_APP_IMG_URL +
													family.business
														.business_img
												}
												alt="family with business"
												style={{	width: "100%",
									height: "250px",
									objectFit: "cover",
									border: "1px dashed #ddd",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									marginBottom: "10px",
									position: "relative",
									backgroundColor: "#f9f9f9",
												 }}
												onClick={() =>
													openImage(
														process.env
															.REACT_APP_IMG_URL +
															family.business
																.business_img
													)
												}
											/>
										) : (
											<div
												style={{ 	height:"150px",alignItems:"center" }}
											>
												<img
													src={noImage}
													alt="No image available"
													style={{
														width: "80px",
														height: "80px",
														display: "block",
														margin: "0 auto",
														opacity: 0.7,
													}}
												/>
												<p
													style={{
														fontSize: "0.9rem",
														color: "red",
														marginTop: "5px",
													}}
												>
													No image found
												</p>
											</div>
										)}
									</Card>
								</Col>

								<Col md={6}>

									<Card className="rounded p-3">
																			<Card.Title>
								<small>Family With Business</small>
							</Card.Title>

										{family?.business
											?.family_with_business ? (
											<img
												className="cnic"
												src={
													process.env
														.REACT_APP_IMG_URL +
													family.business
														.family_with_business
												}
												alt="family with business"
												style={{ 	width: "100%",
									height: "250px",
									objectFit: "cover",
									border: "1px dashed #ddd",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									marginBottom: "10px",
									position: "relative",
									backgroundColor: "#f9f9f9", }}
												onClick={() =>
													openImage(
														process.env
															.REACT_APP_IMG_URL +
															family.business
																.family_with_business
													)
												}
											/>
										) : (
											<div
												style={{ textAlign: "center" ,height:'150px'}}
											>
												<img
													src={noImage}
													alt="No image available"
													style={{
															width: "80px",
														height: "80px",
														display: "block",
														margin: "0 auto",
														opacity: 0.7,
													}}
												/>
												<p
													style={{
														fontSize: "0.9rem",
														color: "red",
														marginTop: "5px",
													}}
												>
													No image found
												</p>
											</div>
										)}
									</Card>
								</Col>
								<Col md={6}>
									<Card className="rounded p-3">
<Card.Title>
								<small>Family Deed Image</small>
							</Card.Title>										{family?.business?.business_deed_img ? (
											<img
												className="cnic"
												src={
													process.env
														.REACT_APP_IMG_URL +
													family.business
														.business_deed_img
												}
												alt="family with business"
												style={{ 	width: "100%",
									height: "250px",
									objectFit: "cover",
									border: "1px dashed #ddd",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									marginBottom: "10px",
									position: "relative",
									backgroundColor: "#f9f9f9", }}
												onClick={() =>
													openImage(
														process.env
															.REACT_APP_IMG_URL +
															family.business
																.business_deed_img
													)
												}
											/>
										) : (
											<div
												style={{ textAlign: "center" ,height:"150px"}}
											>
												<img
													src={noImage}
													alt="No image available"
													style={{
														width: "80px",
														height: "80px",
														display: "block",
														margin: "0 auto",
														opacity: 0.7,
													}}
												/>
												<p
													style={{
														fontSize: "0.9rem",
														color: "red",
														marginTop: "5px",
													}}
												>
													No image found
												</p>
											</div>
										)}
									</Card>
								</Col>

								<Col
					md={6}
					className="mb-4"
				>
					<Card>
						<Card.Body>
							<Card.Title>
								<small>Family Story Video</small>
							</Card.Title>

							<div
								style={{
									width: "100%",
									height: "250px",
									border: "1px dashed #ddd",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									marginBottom: "10px",
									position: "relative",
									backgroundColor: "#f9f9f9",
								}}
							>
								{family.business?.y_link ? (
									<video
										width="100%"
										height="100%"
										controls
										style={{
											objectFit: "cover",
											borderRadius: "8px",
										}}
									>
										<source
											src={
												process.env.REACT_APP_IMG_URL + family?.business?.y_link
												
											}
											type="video/mp4"
										/>
										Your browser does not support the video
										tag.
									</video>
								) : (
									<span style={{ color: "#666" }}>
										No Video Uploaded
									</span>
								)}
							</div>
						</Card.Body>
					</Card>
				</Col>
							</Row>
						</Row>
					</Col>
				</Row>
			</div>

			<div className="mc-card p-lg-4">
				<Row>
					<Col
						xl={12}
						className="mt-5"
					>
						<h5 className="mc-divide-title mb-4">
							Family Follow Up
						</h5>
					</Col>
				</Row>
			</div>
		</PageLayout>
	);
}
